import centsToFormattedString from './cents-to-formatted-string.js';
export default (priceInCents) => centsToFormattedString(priceInCents).replace('$', '$ ');
//# sourceMappingURL=pretty-money.js.map